// Magnet Customizer - Core JavaScript
// Matches circle-customizer-core.js structure, adapted for rectangle magnet

(function() {
  'use strict';

  const SIZE_CONFIGS = {
    '18"x24"': { ratio: [23, 18], exportW: 4600, exportH: 3600 },
    '12"x24"': { ratio: [23, 12], exportW: 4600, exportH: 2400 },
    '10"x20"': { ratio: [20, 10], exportW: 4600, exportH: 2300 },
    '5"x10"':  { ratio: [10.2, 5.2], exportW: 4600, exportH: 2345 },
  };

  const state = {
    selectedSizeKey: null,
    canvas: null,
    ctx: null,
    exportCanvas: null,
    exportCtx: null,
    backgroundColor: '#FFFFFF',
    templateImage: null,
    templateSrc: null,
    uploadedImage: null,
    uploadedImageUrl: null,
    cloudinaryUrl: null,
    uploadedImageX: 0,
    uploadedImageY: 0,
    uploadedImageW: 0,
    uploadedImageH: 0,
    textLines: [],          // array of line state objects
    selectedElement: null,  // { type: 'image' | 'text', index }
    isDragging: false,
    isResizing: false,
    resizeHandle: null,
    dragOffset: { x: 0, y: 0 },
    initialSize: 0,
    initialDistance: 0,
    confirm1: false,
    confirm2: false,
    productData: { quantity: '', size: '', price: '', title: '', variantId: '' }
  };

  const FONTS = ['Roboto','Open Sans','Montserrat','Playfair Display','Lobster','Pacifico','Dancing Script','Bebas Neue','Raleway','Oswald'];
  const MAX_LINES = 5;

  document.addEventListener('DOMContentLoaded', function() {
    initCustomizer();
  });

  function initCustomizer() {
    state.canvas = document.getElementById('magnetDesignCanvas');
    if (!state.canvas) return;
    state.ctx = state.canvas.getContext('2d');

    state.exportCanvas = document.createElement('canvas');
    state.exportCtx = state.exportCanvas.getContext('2d');

    loadProductData();
    setupTabs();
    setupUpload();
    setupTextLines();
    setupBackgroundColors();
    setupTemplates();
    setupConfirmations();
    setupSaveButton();
    setupResetButton();
    setupCanvasInteraction();
  }

  /* ----------------------------------------------------------
     PRODUCT DATA
  ---------------------------------------------------------- */
  function loadProductData() {
    const p = new URLSearchParams(window.location.search);
    state.productData.quantity  = p.get('quantity') || '';
    state.productData.size      = p.get('size') || '';
    state.productData.price     = p.get('price') || '';
    state.productData.title     = p.get('title') || 'Car Magnet';
    state.productData.variantId = p.get('variant') || '';
    window._magnetReturnUrl     = p.get('return_url') || '/';

    const backBtn = document.getElementById('magnetBackBtn');
    if (backBtn) backBtn.href = window._magnetReturnUrl;

    const infoEl = document.getElementById('magnetProductInfo');
    if (infoEl) {
      const parts = [state.productData.title];
      if (state.productData.quantity) parts.push(state.productData.quantity + ' pcs');
      if (state.productData.size)     parts.push(state.productData.size);
      if (state.productData.price)    parts.push('$' + state.productData.price);
      infoEl.textContent = parts.join(' • ');
    }

    // Set size from URL automatically
    const sizeKey = state.productData.size ? decodeURIComponent(state.productData.size) : '18"x24"';
    setTimeout(function() { selectSize(sizeKey, null); }, 200);
  }

  /* ----------------------------------------------------------
     TABS
  ---------------------------------------------------------- */
  function setupTabs() {
    document.querySelectorAll('.magnet-sidebar-icon').forEach(function(icon) {
      icon.addEventListener('click', function() {
        const tab = this.getAttribute('data-tab');
        document.querySelectorAll('.magnet-sidebar-icon').forEach(i => i.classList.remove('active'));
        document.querySelectorAll('.magnet-panel-content').forEach(s => s.classList.remove('active'));
        this.classList.add('active');
        const section = document.querySelector('.magnet-panel-content[data-content="' + tab + '"]');
        if (section) section.classList.add('active');
      });
    });
  }

  /* ----------------------------------------------------------
     SIZE SELECTOR
  ---------------------------------------------------------- */
  function setupSizes() {
    const container = document.getElementById('magnetSizeList');
    if (!container) return;

    let sizes = [];
    const el = document.getElementById('magnetSizesData');
    if (el) { try { sizes = JSON.parse(el.textContent); } catch(e) {} }

    container.innerHTML = '';
    sizes.forEach(function(s) {
      const item = document.createElement('div');
      item.className = 'magnet-size-item';
      item.dataset.sizeKey = s.key;
      item.innerHTML =
        '<div class="magnet-size-item-left">' +
          '<div class="magnet-size-radio"></div>' +
          '<span>' + escHtml(s.label) + '</span>' +
        '</div>' +
        '<span class="magnet-size-price' + (s.isBase ? ' base-price' : '') + '">' + escHtml(s.price) + '</span>';
      item.addEventListener('click', function() { selectSize(s.key, item); });
      container.appendChild(item);
    });
  }

  function selectSize(key, el) {
    state.selectedSizeKey = key;
    document.querySelectorAll('.magnet-size-item').forEach(i => i.classList.remove('selected'));
    if (el) el.classList.add('selected');
    resizeCanvas(getSizeConfig(key));
    updateSaveBtn();
    renderCanvas();
  }

  function getSizeConfig(key) {
    if (SIZE_CONFIGS[key]) return SIZE_CONFIGS[key];
    const clean = k => k.replace(/[^0-9x.]/gi, '').toLowerCase();
    for (const [k, v] of Object.entries(SIZE_CONFIGS)) {
      if (clean(k) === clean(key)) return v;
    }
    return SIZE_CONFIGS['18"x24"'];
  }

  function resizeCanvas(cfg) {
    const [rw, rh] = cfg.ratio;
    const wrapper = document.querySelector('.magnet-canvas-wrapper');
    const maxW = Math.min((wrapper ? wrapper.clientWidth - 60 : 700), 760);
    const maxH = wrapper ? wrapper.clientHeight - 80 : 480;
    const scaleW = maxW / rw;
    const scaleH = maxH / rh;
    const scale = Math.min(scaleW, scaleH);
    state.canvas.width  = Math.round(rw * scale);
    state.canvas.height = Math.round(rh * scale);

    // Reposition uploaded image if present
    if (state.uploadedImage && state.uploadedImageW > 0) {
      state.uploadedImageX = Math.min(state.uploadedImageX, state.canvas.width  - state.uploadedImageW);
      state.uploadedImageY = Math.min(state.uploadedImageY, state.canvas.height - state.uploadedImageH);
    }
    // Reposition text lines
    state.textLines.forEach(function(line) {
      if (line.x > state.canvas.width)  line.x = state.canvas.width  / 2;
      if (line.y > state.canvas.height) line.y = state.canvas.height / 2;
    });
  }

  /* ----------------------------------------------------------
     UPLOAD
  ---------------------------------------------------------- */
  function setupUpload() {
    const area    = document.getElementById('magnetUploadArea');
    const input   = document.getElementById('magnetFileInput');
    const removeBtn = document.getElementById('magnetRemoveImageBtn');

    if (!area || !input) return;

    area.addEventListener('click', function() { input.click(); });
    input.addEventListener('change', function(e) {
      if (e.target.files && e.target.files[0]) handleFile(e.target.files[0]);
    });
    area.addEventListener('dragover', function(e) { e.preventDefault(); area.classList.add('dragging'); });
    area.addEventListener('dragleave', function() { area.classList.remove('dragging'); });
    area.addEventListener('drop', function(e) {
      e.preventDefault();
      area.classList.remove('dragging');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        clearUploadedImage();
        renderCanvas();
      });
    }
  }

  function handleFile(file) {
    if (!file.type.match('image.*')) { showMessage('Please upload a JPG or PNG image.', 'error'); return; }
    if (file.size > 50 * 1024 * 1024) { showMessage('File size must be under 50MB.', 'error'); return; }
    showMessage('Uploading image...', 'info');
    uploadImageToCloudinary(file);
  }

  function uploadImageToCloudinary(file) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', window.magnetCloudinaryConfig.uploadPreset);
    fd.append('folder', window.magnetCloudinaryConfig.folder);

    fetch('https://api.cloudinary.com/v1_1/' + window.magnetCloudinaryConfig.cloudName + '/image/upload', {
      method: 'POST', body: fd
    })
    .then(r => r.json())
    .then(function(data) {
      if (data.secure_url) {
        state.cloudinaryUrl = data.secure_url;
        loadUploadedImage(data.secure_url, file.name, file.size);
        showMessage('Image uploaded!', 'success');
      } else {
        showMessage('Upload failed. Please try again.', 'error');
      }
    })
    .catch(function() { showMessage('Upload failed. Please try again.', 'error'); });
  }

  function loadUploadedImage(url, fileName, fileSize) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      state.uploadedImage    = img;
      state.uploadedImageUrl = url;
      const scale = (state.canvas.width * 0.55) / img.width;
      state.uploadedImageW = img.width  * scale;
      state.uploadedImageH = img.height * scale;
      state.uploadedImageX = (state.canvas.width  - state.uploadedImageW) / 2;
      state.uploadedImageY = (state.canvas.height - state.uploadedImageH) / 2;

      // Show thumbnail
      const infoEl   = document.getElementById('magnetUploadedInfo');
      const thumbEl  = document.getElementById('magnetUploadedThumb');
      const nameEl   = document.getElementById('magnetUploadedFileName');
      const sizeEl   = document.getElementById('magnetUploadedFileSize');
      if (thumbEl) { thumbEl.src = url; }
      if (nameEl)  { nameEl.textContent = fileName; }
      if (sizeEl)  { sizeEl.textContent = fmtSize(fileSize); }
      if (infoEl)  { infoEl.classList.add('visible'); }

      const prompt = document.getElementById('magnetUploadPrompt');
      if (prompt) prompt.style.display = 'none';

      renderCanvas();
    };
    img.src = url;
  }

  function clearUploadedImage() {
    state.uploadedImage    = null;
    state.uploadedImageUrl = null;
    state.cloudinaryUrl    = null;
    state.uploadedImageW   = 0;
    state.uploadedImageH   = 0;

    const infoEl  = document.getElementById('magnetUploadedInfo');
    const thumbEl = document.getElementById('magnetUploadedThumb');
    const input   = document.getElementById('magnetFileInput');
    const prompt  = document.getElementById('magnetUploadPrompt');
    if (infoEl)  infoEl.classList.remove('visible');
    if (thumbEl) thumbEl.src = '';
    if (input)   input.value = '';
    if (prompt)  prompt.style.display = '';

    if (state.selectedElement && state.selectedElement.type === 'image') {
      state.selectedElement = null;
    }
  }

  function fmtSize(b) {
    if (b < 1024) return b + ' B';
    if (b < 1048576) return (b/1024).toFixed(1) + ' KB';
    return (b/1048576).toFixed(1) + ' MB';
  }

  /* ----------------------------------------------------------
     TEXT LINES
  ---------------------------------------------------------- */
  function setupTextLines() {
    const container = document.getElementById('magnetTextLines');
    const mobileContainer = document.getElementById('magnetMobileTextInputs');
    if (!container) return;
    container.innerHTML = '';
    if (mobileContainer) mobileContainer.innerHTML = '';
    state.textLines = [];

    for (let i = 0; i < MAX_LINES; i++) {
      const lineState = {
        text: '', font: FONTS[0], color: '#000000',
        x: 0, y: 0, fontSize: 28, visible: false,
        width: 100, height: 40
      };
      state.textLines.push(lineState);

      const block = document.createElement('div');
      block.className = 'magnet-text-line-block';
      block.innerHTML =
        '<div class="magnet-text-line-num">Line ' + (i+1) + ' <span style="font-weight:400;text-transform:none;">(optional)</span></div>' +
        '<input type="text" class="magnet-text-input" placeholder="Enter text for line ' + (i+1) + '..." maxlength="60" />' +
        '<div class="magnet-font-dropdown" style="margin-bottom:6px;">' +
          '<div class="magnet-font-selected">' + FONTS[0] + '</div>' +
          '<div class="magnet-font-options">' +
            FONTS.map(function(f, fi) {
              return '<div class="magnet-font-option' + (fi === 0 ? ' selected' : '') + '" data-font="' + f + '" style="font-family:\'' + f + '\',sans-serif;">' + f + '</div>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="magnet-color-grid">' +
          [
            { hex: '#FFFFFF', border: true },
            { hex: '#000000' },
            { hex: '#000DCA' },
            { hex: '#009929' },
            { hex: '#FF6C16' },
            { hex: '#FF7EB1' },
            { hex: '#8C52FF' },
            { hex: '#CF0000' },
            { hex: '#FFCE2E' }
          ].map(function(s, si) {
            return '<div class="magnet-color-swatch' + (si === 1 ? ' selected' : '') + '" style="background:' + s.hex + ';' + (s.border ? 'border-color:#ddd;' : '') + '" data-color="' + s.hex + '"></div>';
          }).join('') +
        '</div>';

      const input    = block.querySelector('.magnet-text-input');
      const fontSel  = block.querySelector('.magnet-font-selected');
      const fontOpts = block.querySelector('.magnet-font-options');
      const swatches = block.querySelectorAll('.magnet-color-swatch');

      input.addEventListener('input', function() {
        lineState.text    = this.value;
        lineState.visible = this.value.length > 0;
        if (lineState.visible && lineState.x === 0 && lineState.y === 0) {
          lineState.x = state.canvas.width / 2;
          lineState.y = state.canvas.height / (MAX_LINES + 1) * (i + 1);
        }
        renderCanvas();
      });

      fontSel.addEventListener('click', function(e) {
        e.stopPropagation();
        fontOpts.classList.toggle('open');
        fontSel.classList.toggle('open');
      });

      fontOpts.querySelectorAll('.magnet-font-option').forEach(function(opt) {
        opt.addEventListener('click', function(e) {
          e.stopPropagation();
          fontOpts.querySelectorAll('.magnet-font-option').forEach(o => o.classList.remove('selected'));
          this.classList.add('selected');
          lineState.font = this.getAttribute('data-font');
          fontSel.textContent = lineState.font;
          fontSel.style.fontFamily = "'" + lineState.font + "', sans-serif";
          fontOpts.classList.remove('open');
          fontSel.classList.remove('open');
          renderCanvas();
        });
      });

      swatches.forEach(function(sw) {
        sw.addEventListener('click', function() {
          block.querySelectorAll('.magnet-color-swatch').forEach(s => s.classList.remove('selected'));
          this.classList.add('selected');
          lineState.color = this.getAttribute('data-color');
          if (state.selectedElement && state.selectedElement.type === 'text' &&
              state.selectedElement.index === i) {
            state.textLines[i].color = lineState.color;
          }
          renderCanvas();
        });
      });

      container.appendChild(block);

      // Mobile: full controls matching desktop
      if (mobileContainer) {
        const mBlock = document.createElement('div');
        mBlock.className = 'magnet-text-line-block';
        mBlock.innerHTML =
          '<div class="magnet-text-line-num">Line ' + (i+1) + ' <span style="font-weight:400;text-transform:none;">(optional)</span></div>' +
          '<input type="text" class="magnet-text-input" placeholder="Enter text for line ' + (i+1) + '..." maxlength="60" />' +
          '<div class="magnet-font-dropdown" style="margin-bottom:6px;">' +
            '<div class="magnet-font-selected">' + FONTS[0] + '</div>' +
            '<div class="magnet-font-options">' +
              FONTS.map(function(f, fi) {
                return '<div class="magnet-font-option' + (fi === 0 ? ' selected' : '') + '" data-font="' + f + '" style="font-family:\'' + f + '\',sans-serif;">' + f + '</div>';
              }).join('') +
            '</div>' +
          '</div>' +
          '<div class="magnet-color-grid">' +
            [
              { hex: '#FFFFFF', border: true },
              { hex: '#000000' },
              { hex: '#000DCA' },
              { hex: '#009929' },
              { hex: '#FF6C16' },
              { hex: '#FF7EB1' },
              { hex: '#8C52FF' },
              { hex: '#CF0000' },
              { hex: '#FFCE2E' }
            ].map(function(s, si) {
              return '<div class="magnet-color-swatch' + (si === 1 ? ' selected' : '') + '" style="background:' + s.hex + ';' + (s.border ? 'border-color:#ddd;' : '') + '" data-color="' + s.hex + '"></div>';
            }).join('') +
          '</div>';

        const mInput   = mBlock.querySelector('.magnet-text-input');
        const mFontSel = mBlock.querySelector('.magnet-font-selected');
        const mFontOpts= mBlock.querySelector('.magnet-font-options');
        const mSwatches= mBlock.querySelectorAll('.magnet-color-swatch');

        mInput.addEventListener('input', function() {
          lineState.text    = this.value;
          lineState.visible = this.value.length > 0;
          if (lineState.visible && lineState.x === 0 && lineState.y === 0) {
            lineState.x = state.canvas.width / 2;
            lineState.y = state.canvas.height / (MAX_LINES + 1) * (i + 1);
          }
          // Keep desktop input in sync
          const desktopInput = block.querySelector('.magnet-text-input');
          if (desktopInput) desktopInput.value = this.value;
          renderCanvas();
        });

        mFontSel.addEventListener('click', function(e) {
          e.stopPropagation();
          mFontOpts.classList.toggle('open');
          mFontSel.classList.toggle('open');
        });

        mFontOpts.querySelectorAll('.magnet-font-option').forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            mFontOpts.querySelectorAll('.magnet-font-option').forEach(o => o.classList.remove('selected'));
            this.classList.add('selected');
            lineState.font = this.getAttribute('data-font');
            mFontSel.textContent = lineState.font;
            mFontSel.style.fontFamily = "'" + lineState.font + "', sans-serif";
            mFontOpts.classList.remove('open');
            mFontSel.classList.remove('open');
            renderCanvas();
          });
        });

        mSwatches.forEach(function(sw) {
          sw.addEventListener('click', function() {
            mBlock.querySelectorAll('.magnet-color-swatch').forEach(s => s.classList.remove('selected'));
            this.classList.add('selected');
            lineState.color = this.getAttribute('data-color');
            renderCanvas();
          });
        });

        mobileContainer.appendChild(mBlock);
      }
    }

    // Close font dropdowns when clicking outside
    document.addEventListener('click', function() {
      document.querySelectorAll('.magnet-font-options').forEach(function(el) {
        el.classList.remove('open');
      });
      document.querySelectorAll('.magnet-font-selected').forEach(function(el) {
        el.classList.remove('open');
      });
    });
  }

  /* ----------------------------------------------------------
     BACKGROUND COLORS
  ---------------------------------------------------------- */
  function setupBackgroundColors() {
    const grid = document.getElementById('magnetBgColorGrid');
    if (!grid) return;
    grid.querySelectorAll('.magnet-color-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        grid.querySelectorAll('.magnet-color-swatch').forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');
        state.backgroundColor = this.getAttribute('data-color');
        renderCanvas();
      });
    });

    const resetBtn = document.getElementById('magnetResetBgBtn');
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        state.backgroundColor = '#FFFFFF';
        grid.querySelectorAll('.magnet-color-swatch').forEach(s => s.classList.remove('selected'));
        const white = grid.querySelector('[data-color="#FFFFFF"]');
        if (white) white.classList.add('selected');
        renderCanvas();
      });
    }
  }

  /* ----------------------------------------------------------
     TEMPLATES
  ---------------------------------------------------------- */
  function setupTemplates() {
    const grid = document.getElementById('magnetTemplateGrid');
    const mobileGrid = document.getElementById('magnetMobileTemplateGrid');

    let templates = [];
    const el = document.getElementById('magnetTemplatesData');
    if (el) { try { templates = JSON.parse(el.textContent); } catch(e) {} }

    function buildGrid(container) {
      if (!container) return;
      const noneEl = document.createElement('div');
      noneEl.className = 'magnet-template-none selected';
      noneEl.textContent = 'No Template';
      noneEl.addEventListener('click', function() {
        clearTemplateSelection();
        noneEl.classList.add('selected');
        state.templateImage = null;
        state.templateSrc   = null;
        renderCanvas();
      });
      container.appendChild(noneEl);

      templates.forEach(function(tmpl) {
        const item = document.createElement('div');
        item.className = 'magnet-template-item';
        item.innerHTML =
          '<img src="' + escHtml(tmpl.src) + '" alt="' + escHtml(tmpl.name) + '" loading="lazy" crossorigin="anonymous" />' +
          '<div class="magnet-template-item-label">' + escHtml(tmpl.name) + '</div>';
        item.addEventListener('click', function() {
          clearTemplateSelection();
          item.classList.add('selected');
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() { state.templateImage = img; state.templateSrc = tmpl.src; renderCanvas(); };
          img.onerror = function() { showMessage('Could not load template.', 'error'); };
          img.src = tmpl.src;
        });
        container.appendChild(item);
      });
    }

    buildGrid(grid);
    buildGrid(mobileGrid);
  }

  function clearTemplateSelection() {
    document.querySelectorAll('.magnet-template-item, .magnet-template-none')
      .forEach(el => el.classList.remove('selected'));
  }

  /* ----------------------------------------------------------
     CONFIRMATIONS
  ---------------------------------------------------------- */
  function setupConfirmations() {
    const cb1 = document.getElementById('magnetConfirm1');
    const cb2 = document.getElementById('magnetConfirm2');
    if (cb1) cb1.addEventListener('change', function() { state.confirm1 = this.checked; updateSaveBtn(); });
    if (cb2) cb2.addEventListener('change', function() { state.confirm2 = this.checked; updateSaveBtn(); });
  }

  function updateSaveBtn() {
    const btn = document.getElementById('magnetSaveBtn');
    if (btn) btn.disabled = !(state.confirm1 && state.confirm2);
  }

  /* ----------------------------------------------------------
     CANVAS RENDERING
  ---------------------------------------------------------- */
  function renderCanvas() {
    const ctx = state.ctx;
    const canvas = state.canvas;
    if (!ctx || !canvas) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 1. Background
    ctx.fillStyle = state.backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 2. Template — cover behavior (crop to fill, never distort)
    if (state.templateImage) {
      const img = state.templateImage;
      const scale = Math.max(canvas.width / img.width, canvas.height / img.height);
      const scaledW = img.width * scale;
      const scaledH = img.height * scale;
      const dx = (canvas.width  - scaledW) / 2;
      const dy = (canvas.height - scaledH) / 2;
      ctx.drawImage(img, dx, dy, scaledW, scaledH);
    }

    // 3. Uploaded image
    if (state.uploadedImage) {
      ctx.save();
      ctx.drawImage(state.uploadedImage,
        state.uploadedImageX, state.uploadedImageY,
        state.uploadedImageW, state.uploadedImageH);
      ctx.restore();

      if (state.selectedElement && state.selectedElement.type === 'image') {
        drawSelectionBox('image');
      }
    }

    // 4. Text lines
    state.textLines.forEach(function(line, i) {
      if (!line.visible || !line.text) return;
      drawTextLine(ctx, line, i);
    });
  }

  function drawTextLine(ctx, line, index) {
    ctx.save();
    ctx.font = 'bold ' + line.fontSize + 'px \'' + line.font + '\', sans-serif';
    ctx.fillStyle = line.color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(line.text, line.x, line.y);

    const metrics = ctx.measureText(line.text);
    line.width  = metrics.width + 20;
    line.height = line.fontSize * 1.4;

    if (state.selectedElement && state.selectedElement.type === 'text' &&
        state.selectedElement.index === index) {
      drawSelectionBox('text', index);
    }
    ctx.restore();
  }

  function drawSelectionBox(type, index) {
    const ctx = state.ctx;
    ctx.save();
    ctx.strokeStyle = '#1EAEDB';
    ctx.lineWidth = 2;

    let bx, by, bw, bh;

    if (type === 'image') {
      bx = state.uploadedImageX;
      by = state.uploadedImageY;
      bw = state.uploadedImageW;
      bh = state.uploadedImageH;
    } else {
      const line = state.textLines[index];
      bx = line.x - line.width  / 2;
      by = line.y - line.height / 2;
      bw = line.width;
      bh = line.height;
    }

    ctx.strokeRect(bx, by, bw, bh);

    // Corner handles
    [[bx, by],[bx+bw, by],[bx, by+bh],[bx+bw, by+bh]].forEach(function(pt) {
      ctx.fillStyle = 'white';
      ctx.beginPath();
      ctx.arc(pt[0], pt[1], 7, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#1EAEDB';
      ctx.stroke();
    });

    // Delete button
    const dx = bx + bw, dy = by;
    ctx.fillStyle = '#CF0000';
    ctx.beginPath();
    ctx.arc(dx, dy, 10, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(dx - 4, dy - 4); ctx.lineTo(dx + 4, dy + 4);
    ctx.moveTo(dx + 4, dy - 4); ctx.lineTo(dx - 4, dy + 4);
    ctx.stroke();

    ctx.restore();
  }

  /* ----------------------------------------------------------
     CANVAS INTERACTION
  ---------------------------------------------------------- */
  function setupCanvasInteraction() {
    const canvas = state.canvas;
    canvas.addEventListener('mousedown', onDown);
    canvas.addEventListener('mousemove', onMove);
    canvas.addEventListener('mouseup',   onUp);
    canvas.addEventListener('mouseleave', onUp);

    let pinch = { active: false, startDist: 0, startW: 0, startH: 0, startFontSize: 0 };

    function pinchDist(e) {
      const r = canvas.getBoundingClientRect();
      const sx = canvas.width  / r.width;
      const sy = canvas.height / r.height;
      const dx = (e.touches[0].clientX - e.touches[1].clientX) * sx;
      const dy = (e.touches[0].clientY - e.touches[1].clientY) * sy;
      return Math.sqrt(dx * dx + dy * dy);
    }

    canvas.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2 && state.selectedElement) {
        e.preventDefault();
        pinch.active = true;
        pinch.startDist = pinchDist(e);
        if (state.selectedElement.type === 'image') {
          pinch.startW = state.uploadedImageW;
          pinch.startH = state.uploadedImageH;
        } else {
          pinch.startFontSize = state.textLines[state.selectedElement.index].fontSize;
        }
      } else if (e.touches.length === 1) {
        e.preventDefault();
        pinch.active = false;
        onDown(toMouse(e));
      }
    }, { passive: false });

    canvas.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2 && pinch.active && state.selectedElement) {
        e.preventDefault();
        const ratio = pinchDist(e) / pinch.startDist;
        if (state.selectedElement.type === 'image' && state.uploadedImage) {
          const ar = state.uploadedImage.width / state.uploadedImage.height;
          const newW = Math.max(30, pinch.startW * ratio);
          const newH = newW / ar;
          const cx = state.uploadedImageX + state.uploadedImageW / 2;
          const cy = state.uploadedImageY + state.uploadedImageH / 2;
          state.uploadedImageW = newW;
          state.uploadedImageH = newH;
          state.uploadedImageX = cx - newW / 2;
          state.uploadedImageY = cy - newH / 2;
        } else if (state.selectedElement.type === 'text') {
          const line = state.textLines[state.selectedElement.index];
          line.fontSize = Math.max(8, Math.min(140, pinch.startFontSize * ratio));
        }
        renderCanvas();
      } else if (e.touches.length === 1 && !pinch.active) {
        e.preventDefault();
        onMove(toMouse(e));
      }
    }, { passive: false });

    canvas.addEventListener('touchend', function(e) {
      if (e.touches.length < 2) pinch.active = false;
      if (e.touches.length === 0) onUp();
    });
  }

  function toMouse(e) { const t = e.touches[0]; return { clientX: t.clientX, clientY: t.clientY }; }

  function canvasPos(e) {
    const r = state.canvas.getBoundingClientRect();
    return {
      x: (e.clientX - r.left) * (state.canvas.width  / r.width),
      y: (e.clientY - r.top)  * (state.canvas.height / r.height)
    };
  }

  function onDown(e) {
    const p = canvasPos(e);

    // Check delete button on selected element first
    if (state.selectedElement) {
      const delPos = getDeletePos(state.selectedElement);
      if (delPos && dist(p, delPos) < 12) {
        deleteSelected();
        return;
      }
    }

    // Check resize handles on selected element
    if (state.selectedElement) {
      const handles = getHandles(state.selectedElement);
      for (let i = 0; i < handles.length; i++) {
        if (dist(p, handles[i]) < 10) {
          state.isResizing = true;
          state.resizeHandle = i;
          state.dragStart = p;
          if (state.selectedElement.type === 'image') {
            state.initialSize = state.uploadedImageW;
            state.imageResizeInitH = state.uploadedImageH;
            state.imageResizeInitX = state.uploadedImageX;
            state.imageResizeInitY = state.uploadedImageY;
            // Store the anchor: the corner opposite to the one being dragged
            const x = state.uploadedImageX, y = state.uploadedImageY;
            const w = state.uploadedImageW, h = state.uploadedImageH;
            const anchors = [
              { x: x + w, y: y + h }, // handle 0 = TL, anchor = BR
              { x: x,     y: y + h }, // handle 1 = TR, anchor = BL
              { x: x + w, y: y     }, // handle 2 = BL, anchor = TR
              { x: x,     y: y     }, // handle 3 = BR, anchor = TL
            ];
            state.imageResizeAnchor = anchors[i];
          } else {
            const line = state.textLines[state.selectedElement.index];
            state.initialSize     = line.fontSize;
            state.initialDistance = Math.sqrt(
              Math.pow(p.x - line.x, 2) + Math.pow(p.y - line.y, 2)
            );
          }
          return;
        }
      }
    }

    // Check text lines (reverse = top first)
    for (let i = state.textLines.length - 1; i >= 0; i--) {
      const line = state.textLines[i];
      if (!line.visible || !line.text) continue;
      if (p.x >= line.x - line.width/2  && p.x <= line.x + line.width/2 &&
          p.y >= line.y - line.height/2 && p.y <= line.y + line.height/2) {
        state.selectedElement = { type: 'text', index: i };
        state.isDragging  = true;
        state.isResizing  = false;
        state.dragOffset  = { x: p.x - line.x, y: p.y - line.y };
        renderCanvas();
        return;
      }
    }

    // Check uploaded image
    if (state.uploadedImage) {
      if (p.x >= state.uploadedImageX && p.x <= state.uploadedImageX + state.uploadedImageW &&
          p.y >= state.uploadedImageY && p.y <= state.uploadedImageY + state.uploadedImageH) {
        state.selectedElement = { type: 'image' };
        state.isDragging = true;
        state.isResizing = false;
        state.dragOffset = { x: p.x - state.uploadedImageX, y: p.y - state.uploadedImageY };
        renderCanvas();
        return;
      }
    }

    state.selectedElement = null;
    renderCanvas();
  }

  function onMove(e) {
    const p = canvasPos(e);

    if (state.isResizing && state.selectedElement) {
      if (state.selectedElement.type === 'image') {
        const anchor = state.imageResizeAnchor;
        const ar = state.uploadedImage.width / state.uploadedImage.height;
        const dx = Math.abs(p.x - anchor.x);
        const dy = Math.abs(p.y - anchor.y);
        // Use whichever axis has moved more, maintain aspect ratio
        let newW = Math.max(30, dx / ar > dy ? dx : dy * ar);
        let newH = newW / ar;
        // Position: new top-left depends on which corner is anchored
        const h = state.resizeHandle;
        let newX, newY;
        if (h === 0) { newX = anchor.x - newW; newY = anchor.y - newH; } // TL dragged, BR anchored
        else if (h === 1) { newX = anchor.x;         newY = anchor.y - newH; } // TR dragged, BL anchored
        else if (h === 2) { newX = anchor.x - newW;  newY = anchor.y;        } // BL dragged, TR anchored
        else              { newX = anchor.x;          newY = anchor.y;        } // BR dragged, TL anchored
        state.uploadedImageW = newW;
        state.uploadedImageH = newH;
        state.uploadedImageX = newX;
        state.uploadedImageY = newY;
      } else {
        const line = state.textLines[state.selectedElement.index];
        const currentDist = Math.sqrt(Math.pow(p.x - line.x, 2) + Math.pow(p.y - line.y, 2));
        const ratio = currentDist / state.initialDistance;
        line.fontSize = Math.max(8, Math.min(140, state.initialSize * ratio));
      }
      renderCanvas();
      return;
    }

    if (state.isDragging && state.selectedElement) {
      if (state.selectedElement.type === 'image') {
        state.uploadedImageX = p.x - state.dragOffset.x;
        state.uploadedImageY = p.y - state.dragOffset.y;
      } else {
        const line = state.textLines[state.selectedElement.index];
        line.x = p.x - state.dragOffset.x;
        line.y = p.y - state.dragOffset.y;
      }
      renderCanvas();
    }
  }

  function onUp() {
    state.isDragging = false;
    state.isResizing = false;
  }

  function getHandles(sel) {
    if (sel.type === 'image') {
      const { uploadedImageX: x, uploadedImageY: y, uploadedImageW: w, uploadedImageH: h } = state;
      return [{ x: x, y: y }, { x: x+w, y: y }, { x: x, y: y+h }, { x: x+w, y: y+h }];
    } else {
      const line = state.textLines[sel.index];
      const x = line.x - line.width/2, y = line.y - line.height/2;
      const w = line.width, h = line.height;
      return [{ x: x, y: y }, { x: x+w, y: y }, { x: x, y: y+h }, { x: x+w, y: y+h }];
    }
  }

  function getDeletePos(sel) {
    if (sel.type === 'image') {
      return { x: state.uploadedImageX + state.uploadedImageW, y: state.uploadedImageY };
    } else {
      const line = state.textLines[sel.index];
      return { x: line.x + line.width/2, y: line.y - line.height/2 };
    }
  }

  function deleteSelected() {
    if (!state.selectedElement) return;
    if (state.selectedElement.type === 'image') {
      clearUploadedImage();
    } else {
      const line = state.textLines[state.selectedElement.index];
      const block = document.querySelectorAll('.magnet-text-line-block')[state.selectedElement.index];
      if (block) block.querySelector('.magnet-text-input').value = '';
      line.text = ''; line.visible = false; line.x = 0; line.y = 0;
    }
    state.selectedElement = null;
    renderCanvas();
    showMessage('Element deleted', 'success');
  }

  function dist(a, b) {
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
  }

  /* ----------------------------------------------------------
     SAVE
  ---------------------------------------------------------- */
  function setupSaveButton() {
    const btn = document.getElementById('magnetSaveBtn');
    if (btn) {
      btn.disabled = true;
      btn.addEventListener('click', onSave);
    }
  }

  function onSave() {
    if (!state.confirm1 || !state.confirm2) {
      showMessage('Please check both confirmation boxes first.', 'error');
      // Switch to confirm tab
      const confirmTab = document.querySelector('.magnet-sidebar-icon[data-tab="confirm"]');
      if (confirmTab) confirmTab.click();
      return;
    }
    if (!state.selectedSizeKey) {
      showMessage('Please select a size first.', 'error');
      return;
    }

    state.selectedElement = null;
    renderCanvas();
    showMessage('Generating print-ready file...', 'info');

    const cfg = getSizeConfig(state.selectedSizeKey);

    if (state.uploadedImage && state.cloudinaryUrl) {
      const upscaledUrl = state.cloudinaryUrl.replace('/upload/', '/upload/e_upscale,q_auto:best,f_png/');
      const upscaledImg = new Image();
      upscaledImg.crossOrigin = 'anonymous';
      upscaledImg.onload = function() {
        renderHighRes(cfg, upscaledImg);
        state.exportCanvas.toBlob(function(blob) {
          if (!blob) { showMessage('Error generating file.', 'error'); return; }
          uploadHighRes(blob);
        }, 'image/jpeg', 0.95);
      };
      upscaledImg.onerror = function() {
        renderHighRes(cfg, null);
        state.exportCanvas.toBlob(function(blob) {
          if (!blob) { showMessage('Error generating file.', 'error'); return; }
          uploadHighRes(blob);
        }, 'image/jpeg', 0.95);
      };
      upscaledImg.src = upscaledUrl;
    } else {
      renderHighRes(cfg, null);
      state.exportCanvas.toBlob(function(blob) {
        if (!blob) { showMessage('Error generating file.', 'error'); return; }
        uploadHighRes(blob);
      }, 'image/jpeg', 0.95);
    }
  }

  function renderHighRes(cfg, upscaledImg) {
    state.exportCanvas.width  = cfg.exportW;
    state.exportCanvas.height = cfg.exportH;
    const ec = state.exportCtx;
    const sx = cfg.exportW / state.canvas.width;
    const sy = cfg.exportH / state.canvas.height;

    ec.clearRect(0, 0, cfg.exportW, cfg.exportH);

    // Background
    ec.fillStyle = state.backgroundColor;
    ec.fillRect(0, 0, cfg.exportW, cfg.exportH);

    // Template — cover behavior (crop to fill, never distort)
    if (state.templateImage) {
      const img = state.templateImage;
      const scale = Math.max(cfg.exportW / img.width, cfg.exportH / img.height);
      const scaledW = img.width * scale;
      const scaledH = img.height * scale;
      const dx = (cfg.exportW  - scaledW) / 2;
      const dy = (cfg.exportH - scaledH) / 2;
      ec.drawImage(img, dx, dy, scaledW, scaledH);
    }

    // Uploaded image (use upscaled version if available)
    if (state.uploadedImage) {
            const imgToDraw = upscaledImg || state.uploadedImage;
      ec.drawImage(imgToDraw,
        state.uploadedImageX * sx,
        state.uploadedImageY * sy,
        state.uploadedImageW * sx,
        state.uploadedImageH * sy
      );
    }

    // Text lines
    state.textLines.forEach(function(line) {
      if (!line.visible || !line.text) return;
      ec.save();
      ec.font = 'bold ' + (line.fontSize * sy) + 'px \'' + line.font + '\', sans-serif';
      ec.fillStyle = line.color;
      ec.textAlign = 'center';
      ec.textBaseline = 'middle';
      ec.fillText(line.text, line.x * sx, line.y * sy);
      ec.restore();
    });
  }

  function uploadHighRes(blob) {
    showMessage('Uploading print-ready file...', 'info');
    const fd = new FormData();
    fd.append('file', blob, 'magnet-design-highres.png');
    fd.append('upload_preset', window.magnetCloudinaryConfig.uploadPreset);
    fd.append('folder', window.magnetCloudinaryConfig.folder + '/print-ready');

    fetch('https://api.cloudinary.com/v1_1/' + window.magnetCloudinaryConfig.cloudName + '/image/upload', {
      method: 'POST', body: fd
    })
    .then(r => r.json())
    .then(function(data) {
      if (data.secure_url) {
        uploadPreview(data.secure_url);
      } else {
        showMessage('Upload failed. Please try again.', 'error');
      }
    })
    .catch(function() { showMessage('Upload failed. Please try again.', 'error'); });
  }

  function uploadPreview(highResUrl) {
    state.canvas.toBlob(function(blob) {
      const fd = new FormData();
      fd.append('file', blob, 'magnet-design-preview.jpg');
      fd.append('upload_preset', window.magnetCloudinaryConfig.uploadPreset);
      fd.append('folder', window.magnetCloudinaryConfig.folder + '/previews');

      fetch('https://api.cloudinary.com/v1_1/' + window.magnetCloudinaryConfig.cloudName + '/image/upload', {
        method: 'POST', body: fd
      })
      .then(r => r.json())
      .then(function(data) {
        if (data.secure_url) {
          addToCart(highResUrl, data.secure_url);
        } else {
          showMessage('Upload failed.', 'error');
        }
      })
      .catch(function() { showMessage('Upload failed.', 'error'); });
    }, 'image/jpeg', 0.85);
  }

  function addToCart(highResUrl, previewUrl) {
    if (!state.productData.variantId) {
      // Try to find variant from return URL or product page
      const returnUrl = window._magnetReturnUrl || '';
      const match = returnUrl.match(/variant=(\d+)/);
      if (match) state.productData.variantId = match[1];
    }

    if (!state.productData.variantId) {
      findVariantAndAdd(highResUrl, previewUrl);
      return;
    }
    addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
  }

  function findVariantAndAdd(highResUrl, previewUrl) {
    showMessage('Finding product...', 'info');
    const returnUrl = window._magnetReturnUrl || document.referrer || '';
    let handle = 'car-magnets';
    const m = returnUrl.match(/\/products\/([^?\/]+)/);
    if (m && m[1]) handle = m[1];

    fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .then(function(product) {
        if (product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id;
          state.productData.variantId = variantId;
          addToCartWithVariant(variantId, highResUrl, previewUrl);
        } else {
          showMessage('Could not find product variant.', 'error');
        }
      })
      .catch(function() { showMessage('Error finding product.', 'error'); });
  }

  function addToCartWithVariant(variantId, highResUrl, previewUrl) {
    const textSummary = state.textLines
      .filter(l => l.visible && l.text)
      .map(l => l.text)
      .join(' | ');

    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          'Custom Design': 'Yes - Custom magnet design included',
          '_Design Preview':  previewUrl,
          '_Print File':      highResUrl,
          '_Size Selected':   state.selectedSizeKey || '',
          '_Text Lines':      textSummary || 'No text',
          '_Background Color': state.backgroundColor,
          '_Template Used':   state.templateSrc ? 'Yes' : 'No'
        }
      }]
    };

    showMessage('Adding to cart...', 'info');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function() {
      showMessage('Added to cart! Redirecting...', 'success');
      setTimeout(function() { window.location.href = '/cart'; }, 800);
    })
    .catch(function(err) {
      showMessage('Error adding to cart: ' + err.message, 'error');
    });
  }

  /* ----------------------------------------------------------
     RESET
  ---------------------------------------------------------- */
  function setupResetButton() {
    const btn = document.getElementById('magnetResetBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      if (!confirm('Reset your design? This cannot be undone.')) return;

      state.backgroundColor = '#FFFFFF';
      state.templateImage   = null;
      state.templateSrc     = null;
      state.selectedElement = null;
      clearUploadedImage();

      state.textLines.forEach(function(line, i) {
        line.text = ''; line.visible = false; line.x = 0; line.y = 0; line.fontSize = 28;
        const block = document.querySelectorAll('.magnet-text-line-block')[i];
        if (block) block.querySelector('.magnet-text-input').value = '';
      });

      clearTemplateSelection();
      const noneEl = document.querySelector('.magnet-template-none');
      if (noneEl) noneEl.classList.add('selected');

      const bgGrid = document.getElementById('magnetBgColorGrid');
      if (bgGrid) {
        bgGrid.querySelectorAll('.magnet-color-swatch').forEach(s => s.classList.remove('selected'));
        const white = bgGrid.querySelector('[data-color="#FFFFFF"]');
        if (white) white.classList.add('selected');
      }

      renderCanvas();
      showMessage('Design reset.', 'success');
    });
  }

  /* ----------------------------------------------------------
     MESSAGES
  ---------------------------------------------------------- */
  function showMessage(msg, type) {
    const existing = document.querySelector('.magnet-message-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'magnet-message-toast ' + (type || 'info');
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.animation = 'magnetSlideOut 0.3s ease';
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  /* ----------------------------------------------------------
     HELPERS
  ---------------------------------------------------------- */
  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  window.magnetState  = state;
  window.magnetRender = renderCanvas;

})();

// ============================================
// MOBILE - Panel Controls
// ============================================
(function() {
  'use strict';
  if (window.innerWidth > 768) return;

  const icons    = document.querySelectorAll('.magnet-mobile-icon');
  const panels   = document.querySelectorAll('.magnet-mobile-panel');
  const overlay  = document.querySelector('.magnet-mobile-overlay');
  const closeBtns= document.querySelectorAll('.magnet-mobile-panel-close');
  let activePanel = null;

  icons.forEach(function(icon) {
    icon.addEventListener('click', function() {
      const panelId = this.getAttribute('data-panel');
      const panel   = document.getElementById(panelId);
      panels.forEach(p => { p.classList.remove('active'); p.style.transform = ''; });
      icons.forEach(i => i.classList.remove('active'));
      if (panel) {
        panel.classList.add('active');
        this.classList.add('active');
        overlay && overlay.classList.add('active');
        activePanel = panel;
      }
    });
  });

  function closeAll() {
    panels.forEach(p => { p.style.transition = 'transform 0.3s ease'; p.style.transform = ''; p.classList.remove('active'); });
    icons.forEach(i => i.classList.remove('active'));
    overlay && overlay.classList.remove('active');
    activePanel = null;
  }

  closeBtns.forEach(btn => btn.addEventListener('click', closeAll));
  overlay && overlay.addEventListener('click', closeAll);

  // When keyboard opens, resize active panel to fit above it
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function() {
      const keyboardHeight = window.innerHeight - window.visualViewport.height;
      panels.forEach(function(p) {
        if (p.classList.contains('active')) {
          p.style.maxHeight = (window.visualViewport.height - 70) + 'px';
        } else {
          p.style.maxHeight = '';
        }
      });
    });
  }
})();

// ============================================
// MOBILE - Floating Delete Button
// ============================================
(function() {
  'use strict';
  if (window.innerWidth > 768) return;

  setTimeout(function() {
    const canvas = document.getElementById('magnetDesignCanvas');
    if (!canvas) return;

    // --- Floating delete button ---
    const deleteBtn = document.createElement('button');
    deleteBtn.id = 'magnetMobileDeleteBtn';
    deleteBtn.textContent = 'Delete Selected';
    deleteBtn.style.cssText = [
      'display:none',
      'margin:10px auto 0',
      'background:#CF0000',
      'color:white',
      'border:none',
      'padding:14px 32px',
      'border-radius:25px',
      'font-size:15px',
      'font-weight:600',
      'cursor:pointer',
      'box-shadow:0 4px 16px rgba(207,0,0,0.4)',
      'width:fit-content'
    ].join(';');
    const canvasArea = document.querySelector('.magnet-canvas-area');
    if (canvasArea) canvasArea.appendChild(deleteBtn);
    else document.body.appendChild(deleteBtn);

    setInterval(function() {
      const s = window.magnetState;
      const anyPanelOpen = document.querySelector('.magnet-mobile-panel.active');
      deleteBtn.style.display = (s && s.selectedElement && !anyPanelOpen) ? 'block' : 'none';
    }, 200);

    deleteBtn.addEventListener('click', function() {
      const s = window.magnetState;
      if (!s || !s.selectedElement) return;
      if (s.selectedElement.type === 'image') {
        s.uploadedImage = null; s.uploadedImageUrl = null; s.cloudinaryUrl = null;
        s.uploadedImageW = 0; s.uploadedImageH = 0;
        const infoEl = document.getElementById('magnetUploadedInfo');
        const prompt = document.getElementById('magnetUploadPrompt');
        if (infoEl) infoEl.classList.remove('visible');
        if (prompt) prompt.style.display = '';
      } else if (s.selectedElement.type === 'text') {
        const line = s.textLines[s.selectedElement.index];
        line.text = ''; line.visible = false; line.x = 0; line.y = 0;
        // Clear mobile input
        const mobileInputs = document.querySelectorAll('#magnetMobileTextInputs input');
        if (mobileInputs[s.selectedElement.index]) mobileInputs[s.selectedElement.index].value = '';
        // Clear desktop input
        const desktopBlocks = document.querySelectorAll('#magnetTextLines .magnet-text-input');
        if (desktopBlocks[s.selectedElement.index]) desktopBlocks[s.selectedElement.index].value = '';
      }
      s.selectedElement = null;
      if (window.magnetRender) window.magnetRender();
    });

    

  }, 800);
})();